export default __webpack_public_path__ + "static/media/Snd_ClowerM.e38fa17e.mp3";